export class BookkeepingConfig {
	DefaultSaleCentral:string = "400000";
	DefaultPurchaseCentral:string = "440000";
	DefaultSuspenseAccount:string = "499999";
	VATNotSubtractable:string = "640000";
	DefaultSaleLedgerAccountCode:string = "700000"
DefaultPurchaseLedgerAccountCode:string = "600100"
	BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.DefaultSaleCentral = data.DefaultSaleCentral;
		this.DefaultPurchaseCentral = data.DefaultPurchaseCentral;
		this.DefaultSuspenseAccount = data.DefaultSuspenseAccount ? data.DefaultSuspenseAccount : "499999";
		this.VATNotSubtractable = data.VATNotSubtractable ? data.VATNotSubtractable : "640000";
		this.DefaultSaleLedgerAccountCode = data.DefaultSaleLedgerAccountCode;
		this.DefaultPurchaseLedgerAccountCode = data.DefaultPurchaseLedgerAccountCode;
		this.BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger = data.BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger;
	}

	public getJSON(){
		return {
			DefaultSaleCentral: this.DefaultSaleCentral,
			DefaultPurchaseCentral: this.DefaultPurchaseCentral,
			DefaultSuspenseAccount: this.DefaultSuspenseAccount,
			VATNotSubtractable: this.VATNotSubtractable,
			DefaultSaleLedgerAccountCode: this.DefaultSaleLedgerAccountCode,
			DefaultPurchaseLedgerAccountCode: this.DefaultPurchaseLedgerAccountCode,
			BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger: this.BookOpenClientsAndSuppliersAutomaticallyOnWaitLedger
		};
	}
}